import { Button, IconButton, InputAdornment } from '~/UIKit';
import { TextField } from 'formik-material-ui';
import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { TFunction } from 'i18next';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { passwordValidationScheme } from '../../Helpers/Validators.helper';
import { makeStyles } from '~/UIKit/Style';

export type NewPasswordFormState = {
  password: string;
  password_confirmation: string;
};

type NewPasswordFormProps = {
  onSubmit: (values: NewPasswordFormState) => void;
  t: TFunction;
  loading?: boolean;
};

const INITIAL_VALUES: NewPasswordFormState = {
  password: '',
  password_confirmation: '',
};

const useStyles = makeStyles({
  submitButton: {
    marginTop: 30,
  },
});

const NewPasswordForm = ({ onSubmit, t, loading = false }: NewPasswordFormProps) => {
  const { classes } = useStyles();
  const [isPasswordVisible, togglePasswordVisibility] = useState(false);

  const onShowPasswordClick = () => {
    togglePasswordVisibility(!isPasswordVisible);
  };

  const handleMouseDownPassword = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  const passwordFieldType = isPasswordVisible ? 'text' : 'password';

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        edge="end"
        onClick={onShowPasswordClick}
        onMouseDown={handleMouseDownPassword}
        size="large"
      >
        {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <>
      <Formik
        initialValues={INITIAL_VALUES}
        onSubmit={onSubmit}
        validationSchema={() => passwordValidationScheme(t)}
      >
        {() => (
          <Form>
            <Field
              InputProps={{ endAdornment }}
              component={TextField}
              disabled={loading}
              fullWidth
              id="password"
              label={t('app.password')}
              margin="dense"
              name="password"
              placeholder={t('app.password')}
              type={passwordFieldType}
            />
            <Field
              InputProps={{ endAdornment }}
              component={TextField}
              disabled={loading}
              fullWidth
              id="password_confirmation"
              label={t('app.confirmPassword')}
              margin="dense"
              name="password_confirmation"
              placeholder={t('app.confirmPassword')}
              type={passwordFieldType}
            />
            <Button
              className={classes.submitButton}
              color="primary"
              disabled={loading}
              fullWidth
              type="submit"
              variant="contained"
              isLoading={loading}
            >
              {t('app.resetPassword')}
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewPasswordForm;
